// extracted by mini-css-extract-plugin
export default {"galleryImage":"GalleryMediaBox_galleryImage__t38ae"};